import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import DebitNotesTable from "@/components/invoices/debits/debit-notes-table";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

const debitNotesSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
  reason: z.string().optional(),
  numericRanges: z.string().optional(),
});

export const Route = createFileRoute(
  "/_authenticated/invoices/debit-notes/",
)({
  validateSearch: debitNotesSearchSchema,
  component: DebitNotesPage,
});

function DebitNotesPage() {
  const searchParams = Route.useSearch();

  return (
    <RouteGuardPermissions
      permissions={[{ module: "debit_notes", actions: ["read"] }]}
    >
      <DebitNotesTable
      currentPage={searchParams.page}
      basePath="/invoices/debit-notes"
      searchParams={searchParams}
    />
    </RouteGuardPermissions>
  );
}
